  <template>
    <div class="bg">
      <div class="logo">
              <img  src="../assets/freshworkslogo.svg"  align="middle" >
      </div>
      
       <b-container class="box-container w-25 login-container" >
        
        <h3><img src="../assets/userlogin.svg" ></h3>
        <h3>Login</h3>
        <div style="justify-content: center;display: flex;">
            <b-button variant="primary" @click="oauthsignin">Sign in using Google login</b-button>
            </div>
        </b-container>

    </div>
  </template>

<script>
import http from "../http-common"

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'login',
  data() {
    return {
      text: '',
      usernamestate: null,
      passwordstate: null,
      user: {
         username: '',
         password: ''
      },
      form: {
          username: '',
         password: ''
        },
        connected: false
    };
  },
  methods: {
    ...mapActions([
       'disconnect_actions',
       'commitseenmessage',
       'commitstackname'
      ]),
    oauthsignin(){
      this.$gAuth.signIn()
          .then(GoogleUser => {
            this.login(GoogleUser.getBasicProfile().U3)
            this.isSignIn = this.$gAuth.isAuthorized
          })
          .catch(error  => {
            console.log("error",error)
          })
    },
    onSubmit(evt) {
        evt.preventDefault()
        this.user['username'] = this.form.username
        this.user['password'] = this.form.password
        this.login();
      },
      onReset(evt) {
        evt.preventDefault()
        this.form.username = ''
        this.form.password = ''
      },
      clearName() {
        this.user['username'] = ''
        this.user['password'] = ''
      },
    async login(email) {
      http
        .post("/login", email)
        .then(response => {
          this.text = response.data[0]
          if(this.text == "Valid User"){
            this.$session.start()
            this.$session.set("username",response.data[2])
            this.$session.set("role",response.data[1])
            this.$session.set("stackname",'')
            this.retrieveUsed(response.data[2])
            this.$router.push({ path: '/dashboard'})
          }else{
            this.disconnect_actions()
            if(this.text=="Not Valid Username"){
              this.usernamestate=false
            }else{
              this.passwordstate=false
            }
          this.$router.push({ name: 'login'})
        }
        })
        .catch(e => {
          console.log(e);
        });

      },
      async retrieveUsed(name) {
        await http
        .post("/used",name)
        .then(response => {
          if(response.data[0]!=null){
              this.$session.set("stackname",response.data[0]['stackname'])
              this.commitstackname(response.data[0]['stackname'])
          }else{
              this.$session.set("stackname","")
            }
        })  
        .catch(e => {
          console.log(e)
        });
      }
    },
    computed: {
      stateuser() {
        if(this.text != ""){
          return this.text  == "Not Valid Username" ? true : false
        }
        return false;
      },
      invalidFeedback1() {
        return this.stateuser === true ? '' : this.text
      },
      statepsw() {
        if(this.text != ""){
          return this.text  == "Not Valid Password" ? true : false
        }
        return false;
      },
      invalidFeedback2() {
        return this.statepsw === true ? '' : this.text
      },
        ...mapGetters([
          'getsessioncheck',
          'getseenmessage'
        ])
      },
    watch: {
      getsessioncheck: function(val){
          if(val==true){
                this.commitidleSecondsCounter(0)
                this.$router.push({ name: 'dashboard'})
          }
      }
    },
  created() {
  }


}
</script>
<style>
.bg {
  background-image: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),url("../assets/background-image.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width:100%;
  min-height: 100%; 
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
}
.login-container{
  margin-top:100px;
}
.box-container label{
      color: #9a9a9a;
      text-align: left;
      margin-bottom: 0;
}
.box-container h3{
  color: #333;
  font-weight: 300;
  line-height: 1.2;
  text-align:center;
}
</style>
